const initialState = () => ({
  isOpened: false,
  padDiagnostic: {},
  onSuccessCallback: null,
  modalData: {
    title: '',
    description: '',
    confirmationTerm: ''
  }
});

const ACTION_KEY = 'PAD_CREATOR_DIAGNOSTIC_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { padDiagnostic, modalData, onSuccessCallback } = action.payload;
      return {
        ...state,
        isOpened: true,
        padDiagnostic,
        modalData,
        onSuccessCallback
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
